function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange",
    "initialOpen"
], _excluded2 = [
    "MenuProps"
];
import * as React from 'react';
import PropTypes from 'prop-types';
import { unstable_useEnhancedEffect as useEnhancedEffect } from '@mui/utils';
import { GridCellEditStopReasons } from "../../models/params/gridEditCellParams.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { GridEditModes } from "../../models/gridEditRowModel.js";
import { getValueFromValueOptions, getValueOptions, isSingleSelectColDef } from "../panel/filterPanel/filterPanelUtils.js";
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.js";
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function isKeyboardEvent(event) {
    return !!event.key;
}
function GridEditSingleSelectCell(props) {
    var _rootProps_slotProps, _rootProps_slotProps1;
    var rootProps = useGridRootProps();
    var id = props.id, valueProp = props.value, field = props.field, row = props.row, colDef = props.colDef, hasFocus = props.hasFocus, error = props.error, onValueChange = props.onValueChange, _props_initialOpen = props.initialOpen, initialOpen = _props_initialOpen === void 0 ? rootProps.editMode === GridEditModes.Cell : _props_initialOpen, other = _objectWithoutPropertiesLoose(props, _excluded);
    var apiRef = useGridApiContext();
    var ref = React.useRef(null);
    var inputRef = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(initialOpen), 2), open = _React_useState[0], setOpen = _React_useState[1];
    var baseSelectProps = ((_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.baseSelect) || {};
    var _baseSelectProps_native;
    var isSelectNative = (_baseSelectProps_native = baseSelectProps.native) !== null && _baseSelectProps_native !== void 0 ? _baseSelectProps_native : false;
    var _ref = ((_rootProps_slotProps1 = rootProps.slotProps) === null || _rootProps_slotProps1 === void 0 ? void 0 : _rootProps_slotProps1.baseSelect) || {}, MenuProps = _ref.MenuProps, otherBaseSelectProps = _objectWithoutPropertiesLoose(_ref, _excluded2);
    useEnhancedEffect(function() {
        if (hasFocus) {
            var _inputRef_current;
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
        }
    }, [
        hasFocus
    ]);
    if (!isSingleSelectColDef(colDef)) {
        return null;
    }
    var valueOptions = getValueOptions(colDef, {
        id: id,
        row: row
    });
    if (!valueOptions) {
        return null;
    }
    var getOptionValue = colDef.getOptionValue;
    var getOptionLabel = colDef.getOptionLabel;
    var handleChange = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var target, formattedTargetValue;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSingleSelectColDef(colDef) || !valueOptions) {
                            return [
                                2
                            ];
                        }
                        setOpen(false);
                        target = event.target;
                        // NativeSelect casts the value to a string.
                        formattedTargetValue = getValueFromValueOptions(target.value, valueOptions, getOptionValue);
                        if (!onValueChange) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onValueChange(event, formattedTargetValue)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            apiRef.current.setEditCellValue({
                                id: id,
                                field: field,
                                value: formattedTargetValue
                            }, event)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = function(event, reason) {
        if (rootProps.editMode === GridEditModes.Row) {
            setOpen(false);
            return;
        }
        if (reason === 'backdropClick' || event.key === 'Escape') {
            var params = apiRef.current.getCellParams(id, field);
            apiRef.current.publishEvent('cellEditStop', _extends({}, params, {
                reason: event.key === 'Escape' ? GridCellEditStopReasons.escapeKeyDown : GridCellEditStopReasons.cellFocusOut
            }));
        }
    };
    var handleOpen = function(event) {
        if (isKeyboardEvent(event) && event.key === 'Enter') {
            return;
        }
        setOpen(true);
    };
    if (!valueOptions || !colDef) {
        return null;
    }
    return /*#__PURE__*/ _jsx(rootProps.slots.baseSelect, _extends({
        ref: ref,
        inputRef: inputRef,
        value: valueProp,
        onChange: handleChange,
        open: open,
        onOpen: handleOpen,
        MenuProps: _extends({
            onClose: handleClose
        }, MenuProps),
        error: error,
        native: isSelectNative,
        fullWidth: true
    }, other, otherBaseSelectProps, {
        children: valueOptions.map(function(valueOption) {
            var _rootProps_slotProps;
            var value = getOptionValue(valueOption);
            return /*#__PURE__*/ _createElement(rootProps.slots.baseSelectOption, _extends({}, ((_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.baseSelectOption) || {}, {
                native: isSelectNative,
                key: value,
                value: value
            }), getOptionLabel(valueOption));
        })
    }));
}
process.env.NODE_ENV !== "production" ? GridEditSingleSelectCell.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * GridApi that let you manipulate the grid.
   */ api: PropTypes.object.isRequired,
    /**
   * The mode of the cell.
   */ cellMode: PropTypes.oneOf([
        'edit',
        'view'
    ]).isRequired,
    changeReason: PropTypes.oneOf([
        'debouncedSetEditCellValue',
        'setEditCellValue'
    ]),
    /**
   * The column of the row that the current cell belongs to.
   */ colDef: PropTypes.object.isRequired,
    /**
   * The column field of the cell that triggered the event.
   */ field: PropTypes.string.isRequired,
    /**
   * The cell value formatted with the column valueFormatter.
   */ formattedValue: PropTypes.any,
    /**
   * If true, the cell is the active element.
   */ hasFocus: PropTypes.bool.isRequired,
    /**
   * The grid row id.
   */ id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    /**
   * If true, the select opens by default.
   */ initialOpen: PropTypes.bool,
    /**
   * If true, the cell is editable.
   */ isEditable: PropTypes.bool,
    isProcessingProps: PropTypes.bool,
    isValidating: PropTypes.bool,
    /**
   * Callback called when the value is changed by the user.
   * @param {SelectChangeEvent<any>} event The event source of the callback.
   * @param {any} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */ onValueChange: PropTypes.func,
    /**
   * The row model of the row that the current cell belongs to.
   */ row: PropTypes.any.isRequired,
    /**
   * The node of the row that the current cell belongs to.
   */ rowNode: PropTypes.object.isRequired,
    /**
   * the tabIndex value.
   */ tabIndex: PropTypes.oneOf([
        -1,
        0
    ]).isRequired,
    /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */ value: PropTypes.any
} : void 0;
export { GridEditSingleSelectCell };
export var renderEditSingleSelectCell = function(params) {
    return /*#__PURE__*/ _jsx(GridEditSingleSelectCell, _extends({}, params));
};
